import { render, staticRenderFns } from "./third-telephone-book.vue?vue&type=template&id=264196f6&scoped=true"
import script from "./third-telephone-book.vue?vue&type=script&lang=ts"
export * from "./third-telephone-book.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264196f6",
  null
  
)

export default component.exports